import { render } from "./NotificationTabs.vue?vue&type=template&id=3d3fd515&scoped=true&ts=true"
import script from "./NotificationTabs.vue?vue&type=script&lang=ts"
export * from "./NotificationTabs.vue?vue&type=script&lang=ts"

import "./NotificationTabs.vue?vue&type=style&index=0&id=3d3fd515&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d3fd515"]])

export default __exports__